import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { withLoading } from '@front-activerse/common-components';
import TrackerAddEditMeal from '../components/TrackerAddEditMeal';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { normalizeDietMeal } from '../helpers/normalizers';
import { DietMealProps } from '../types';

const TrackerAddDietMealContainer: React.FC<DietMealProps & { dietMealId?: string }> = (props) => {
  const normalizedProps = normalizeDietMeal(props);
  const [searchParams] = useSearchParams();
  const webviewModal = searchParams.get('webviewModal') === 'true';
  sessionStorage.setItem('tracker_depth', '1');
  return (
    <TrackerAddEditMeal
      key={normalizedProps.mealData.id}
      {...normalizedProps}
      dietMealId={props.dietMealId}
      webviewModal={webviewModal}
    />
  );
};

export default withLoading(TrackerAddDietMealContainer, UniversalPlaceholder);
